import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kitchen_cookware: FaireCategoryEntity = {
  token: "cat_kitchen-cookware",
  type: "category",
  name: "Cookware & bakeware",
  level: 3,
  parentToken: "cat_home-decor-kitchen-tabletop",
  href: "/category/home-decor/kitchen-tabletop/cookware-bakeware",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
